import React from "react";
import { Styled } from "./styles";
import { Typography, TypographyProps } from "@mui/material";

interface Props extends TypographyProps {
    title: string;
}

const SectionTitle: React.FC<Props> = ({ title, ...props }) => {
    return (
        <Styled.Title>
            <Typography variant="h5" {...props}>
                {title}
            </Typography>
            <Styled.Placeholder />
        </Styled.Title>
    );
};

export default SectionTitle;
